/**
 * 指导老师接口（T77）。
 * 契约：
 *   GET    /advisors           → {advisors}（已认证导师，含实时余量）
 *   POST   /teams/:id/advisor  → {team}（body {advisorUserId}；仅队长，409 = 已有导师/名额满）
 *   DELETE /teams/:id/advisor  → {team}（仅队长，404 = 未绑定）
 */
import { api } from './client.js';
import type { AdvisorListDto, TeamDto } from './types.js';

export const advisorsApi = {
  list: (): Promise<AdvisorListDto> => api.get<AdvisorListDto>('/advisors'),

  bind: (teamId: string, advisorUserId: string): Promise<{ team: TeamDto }> =>
    api.post<{ team: TeamDto }>(`/teams/${encodeURIComponent(teamId)}/advisor`, { advisorUserId }),

  unbind: (teamId: string): Promise<{ team: TeamDto }> =>
    api.delete<{ team: TeamDto }>(`/teams/${encodeURIComponent(teamId)}/advisor`),
};
